import {
  ControlledMenu,
  MenuItem,
  MenuState,
  MenuDivider,
} from "@szhsin/react-menu";
import styled, { keyframes } from "styled-components";
import {
  menuSelector,
  menuItemSelector,
  menuDividerSelector,
} from "@szhsin/react-menu/style-utils";
import React from "react";
import { IconContainer } from "../ReportTabs/TabsContent/reportDataPiece/menu/dataPieceMenu";
import UnpinIcon from "../../../../assets/images/UnPinIcon.svg";
import { VscPinned as PinIcon } from "react-icons/vsc";

interface CustomMenuProps {
  minWidth?: string;
  maxWidth?: string;
}

type Props = {
  isMenuOpen: boolean;
  pinnedToDashboard?: boolean;
  togglePinDashboard?: (value: boolean) => void;
  toggleMenu: (menuState: boolean) => void;
  minWidth?: string;
  maxWidth?: string;
};

const menuShow = keyframes`
  from {
    opacity: 0;
  }
`;
const menuHide = keyframes`
  to {
    opacity: 0;
  }
`;

export const CustomMenu = styled(ControlledMenu) <CustomMenuProps>`
  ${menuSelector.name} {
    font-size: 0.8rem;
    user-select: none;
    box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.15);
    border-radius: 0.3125rem;
    border: 1px solid #D1D1D1;
    /* padding: 6px; */
    min-width: ${({ minWidth }) => minWidth || '18rem'};
    max-width: ${({ maxWidth }) => maxWidth || '18rem'};
    z-index: 101;
    
  }

  ${menuDividerSelector.name} {
    background-color: #d1d1d1;
  }

  ${menuItemSelector.name} {
    display: flex;
    align-items: "center";
    gap: 1rem;
    padding: 0.3rem 1.2rem;
    color: #808080;
  }

  ${menuItemSelector.disabled} {
    opacity: 0.5;
  }

  ${menuItemSelector.hover} {
    background-color: #fff;
  }

  ${menuSelector.stateOpening} {
    animation: ${menuShow} 0.15s ease-out;
  }
`;

const CardMenu = React.forwardRef(
  (
    { isMenuOpen, pinnedToDashboard, togglePinDashboard, toggleMenu, minWidth = "18rem", maxWidth = "18rem" }: Props,
    ref: any
  ) => {
    return (
      <CustomMenu
        state={isMenuOpen ? "open" : "closed"}
        anchorRef={ref}
        onClose={() => {
          toggleMenu(false);
        }}
        minWidth={"15rem"}
        maxWidth={"15rem"}
      >
        <MenuItem onClick={() => togglePinDashboard(!pinnedToDashboard)}>
          <IconContainer>
            {pinnedToDashboard ? (
              <img
                style={{ paddingLeft: "0.2rem", width: "0.9rem" }}
                src={UnpinIcon}
              />
            ) : (
              <PinIcon />
            )}
          </IconContainer>
          <div>
            {!pinnedToDashboard ? "Pin to Dashboard" : "Unpin from Dashboard"}
          </div>
        </MenuItem>
      </CustomMenu>
    );
  }
);

export default CardMenu;
